/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editprofile1Inputs */

const en_editprofile1 = /** @type {(inputs: Editprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Profile`)
};

const de_editprofile1 = /** @type {(inputs: Editprofile1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit Profile" |
*
* @param {Editprofile1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editprofile1 = /** @type {((inputs?: Editprofile1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editprofile1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editprofile1(inputs)
	return de_editprofile1(inputs)
});
export { editprofile1 as "editProfile" }